import { Dimensions, StyleSheet } from 'react-native';
import { Colors } from '../../constants/Colors';
const commonDotStyle = {
    width: 10,
    height: 10,
    borderRadius: 50,
    marginRight: 10,
  };
export default StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f9f9f9',
    padding: 20,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: 20,
  },
  skeletonContainer: {
    padding: 16,
    backgroundColor: '#fff',
    borderRadius: 8,
    margin: 8,
  },
  skeletonTitle: {
    height: 24,
    backgroundColor: '#f0f0f0',
    borderRadius: 4,
    marginBottom: 12,
    width: '70%',
  },
  skeletonSubtitle: {
    height: 18,
    backgroundColor: '#f0f0f0',
    borderRadius: 4,
    marginBottom: 24,
    width: '50%',
  },
  skeletonSectionTitle: {
    height: 20,
    backgroundColor: '#f0f0f0',
    borderRadius: 4,
    marginBottom: 16,
    width: '40%',
  },
  skeletonSeparator: {
    marginTop: 20,
  },
  skeletonItemContainer: {
    flexDirection: 'row',
    marginBottom: 16,
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 8,
  },
  skeletonItemImage: {
    width: 60,
    height: 60,
    borderRadius: 4,
    backgroundColor: '#f0f0f0',
    marginRight: 12,
  },
  skeletonTextShort: {
    height: 14,
    backgroundColor: '#f0f0f0',
    borderRadius: 4,
    marginBottom: 8,
    width: '30%',
  },
  skeletonTextLong: {
    height: 14,
    backgroundColor: '#f0f0f0',
    borderRadius: 4,
    marginBottom: 8,
    width: '80%',
  },
  skeletonPrice: {
    height: 16,
    backgroundColor: '#f0f0f0',
    borderRadius: 4,
    width: '40%',
  },
  skeletonDiscountPrice: {
    height: 16,
    backgroundColor: '#f0f0f0',
    borderRadius: 4,
    width: '50%',
  },
  skeletonSubtotalText: {
    height: 18,
    backgroundColor: '#f0f0f0',
    borderRadius: 4,
    marginVertical: 16,
    width: '60%',
    alignSelf: 'flex-end',
  },
  skeletonDescription: {
    height: 16,
    backgroundColor: '#f0f0f0',
    borderRadius: 4,
    marginBottom: 16,
    width: '90%',
  },
  skeletonButton: {
    height: 44,
    backgroundColor: '#f0f0f0',
    borderRadius: 22,
    marginTop: 16,
    width: '100%',
  },
  sectionSeparator: {
    borderBottomWidth: 1,
    borderBottomColor: '#e0e0e0',
    marginVertical: 10,
    paddingBottom: 10,
  },
  card: {
    flex: 1,
    padding: 15,
    marginVertical: 10,
    marginHorizontal: 20,
    backgroundColor: '#fff',
    borderRadius: 8,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowRadius: 5,
    elevation: 3,
    maxHeight: Dimensions.get('window').height * 0.8,
  },
  scrollContainer: {
    paddingBottom: 20,
  },
  freeBadge: {
    backgroundColor: Colors.GreenPallete.greenOne,
    paddingVertical: 2,
    borderRadius: 4,
    margin: 5,
  width: '25%',
  alignItems: 'center',
    
  },
  freeText: {
    color: '#fff',
    fontSize: 10,
    fontWeight: 'bold',
  },
  comboTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 10,
    color: '#333',
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginTop: 10,
    marginBottom: 5,
    color: '#555',
  },
  subtotalText: {
    fontSize: 14,
    fontWeight: 'bold',
    marginTop: 10,
    color: '#444',
    marginBottom: 15,
  },
  itemContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
    padding: 10,
    backgroundColor: '#f0f0f0',
    borderRadius: 8,
  },
  priceOriginal: {
    fontSize: 14,
    color: '#999',
    textDecorationLine: 'line-through',
    marginRight: 5,
  },
  priceDiscounted: {
    fontSize: 16,
    color: '#388e3c',
    fontWeight: 'bold',
  },
  itemImage: {
    width: 50,
    height: 50,
    borderRadius: 8,
    marginRight: 10,
  },
  itemText: {
    fontSize: 14,
    color: '#333',
    flex: 1,
  },
  header: {
    fontSize: 20,
    fontWeight: 'bold',
    marginVertical: 10,
    textAlign: 'center',
    color: '#333',
  },
  controlsButton: {
    padding: 10,
  },
  dotStyle: {
    backgroundColor: '#ccc',
    width: 8,
    height: 8,
    borderRadius: 4,
    marginHorizontal: 4,
  },
  activeDotStyle: {
    backgroundColor: '#E91E63',
    width: 10,
    height: 10,
    borderRadius: 5,
    marginHorizontal: 4,
  },
  textContainer: {
    flex: 1,
    justifyContent: 'center',
  },
});
